export type ConsentPreferences = {
  necessary: true;
  analytics: boolean;
  advertising: boolean;
};

export type CookieConsentContextType = {
  preferences: ConsentPreferences | null;
  isConsentGiven: boolean;
  isHydrated: boolean;
  updatePreferences: (preferences: Partial<Omit<ConsentPreferences, "necessary">>) => void;
  acceptAll: () => void;
  acceptNecessaryOnly: () => void;
};

export const CONSENT_STORAGE_KEY = "cookie_consent_preferences";

export const DEFAULT_PREFERENCES: ConsentPreferences = {
  necessary: true,
  analytics: false,
  advertising: false,
};
